(function () {
  if (window.BloomliCartRoutineUpsellInitialized) return;
  window.BloomliCartRoutineUpsellInitialized = true;

  function getRequestedSections() {
    var sections = ['cart-icon-bubble'];
    if (document.getElementById('CartDrawer')) sections.push('cart-drawer');
    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var el = selector ? parsed.querySelector(selector) : parsed.querySelector('.shopify-section');
    return el ? el.innerHTML : '';
  }

  function replaceCartSections(parsedState) {
    if (!parsedState.sections) return;

    var cartDrawerHtml = parsedState.sections['cart-drawer'];
    if (cartDrawerHtml) {
      var html = new DOMParser().parseFromString(cartDrawerHtml, 'text/html');
      [
        ['.drawer__header',                      '.drawer__header'],
        ['[data-bloomli-cart-shipping]',         '[data-bloomli-cart-shipping]'],
        ['cart-drawer-items',                    'cart-drawer-items'],
        ['.drawer__footer',                      '.drawer__footer'],
      ].forEach(function (pair) {
        var target = document.querySelector(pair[0]);
        var source = html.querySelector(pair[1]);
        if (target && source) {
          target.replaceWith(source);
        } else if (target && !source && pair[0] === '[data-bloomli-cart-shipping]') {
          target.remove();
        }
      });

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    var cartIconHtml = parsedState.sections['cart-icon-bubble'];
    if (cartIconHtml) {
      var cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIcon) cartIcon.innerHTML = getSectionInnerHTML(cartIconHtml);
    }
  }

  function showError() {
    var errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
  }

  function setLoading(btn, loading) {
    var card = btn.closest('[data-bloomli-routine-upsell]');
    var buttons = card
      ? card.querySelectorAll('[data-bloomli-routine-upsell-btn], [data-bloomli-routine-upsell-otp-btn]')
      : [btn];

    buttons.forEach(function (button) {
      button.disabled = loading;
    });

    if (card) {
      card.classList.toggle('is-loading', loading);
      card.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
  }

  function addToCart(btn, sellingPlanId) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    var quantity = 1;

    setLoading(btn, true);

    var item = { id: variantId, quantity: quantity };
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    var body = JSON.stringify({
      items: [item],
      sections: getRequestedSections(),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_add_url, Object.assign({}, fetchConfig(), { body: body }))
      .then(function (response) { return response.text(); })
      .then(function (state) {
        var parsedState = JSON.parse(state);
        if (parsedState.status === 422 || parsedState.errors) {
          showError();
          return;
        }
        replaceCartSections(parsedState);
        if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bloomli-cart-routine-upsell',
            cartData: parsedState,
          });
        }
      })
      .catch(showError)
      .finally(function () {
        if (document.body.contains(btn)) setLoading(btn, false);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-bloomli-routine-upsell-btn]');
    if (btn) {
      event.preventDefault();
      var planId = btn.dataset.sellingPlanId ? parseInt(btn.dataset.sellingPlanId, 10) : null;
      addToCart(btn, planId);
      return;
    }

    var otpBtn = event.target.closest('[data-bloomli-routine-upsell-otp-btn]');
    if (otpBtn) {
      event.preventDefault();
      addToCart(otpBtn, null);
    }
  });
})();
